import { setRebrandingEnabled } from "@src/appV2/redesign/system/ui-theme";

const REBRANDING_LOCAL_STORAGE_KEY = "worker-app-rebranding-enabled";

const isEnabled = localStorage.getItem(REBRANDING_LOCAL_STORAGE_KEY) === "true";

if (isEnabled) {
  setRebrandingEnabled(true);
}

export { REBRANDING_LOCAL_STORAGE_KEY };
